// extracted by mini-css-extract-plugin
export default {"navLayout":"App_navLayout__N4O0D","navButton":"App_navButton__00F+X","clickedButton":"App_clickedButton__wJEk6"};